import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from "rxjs";
import { Guid } from "guid-typescript";
import {
  ProblemGetModel, ProblemGobalSearch, ProblemNotesGetModel, ProblemSummaryModel, RelationshipGetModel,
  SearchProblemCodeModel, TrustIncidentGetModel
} from '@app/models/failure/problem.model';

@Injectable({ providedIn: 'root' })
export class ProblemService {

  private apiUrl = `${environment.apiUrl}/api/problem/`;
  private apiUrl_GIS = `${environment.apiUrl}/api/gis/`;

  constructor(private httpClient: HttpClient) { }

  public getDashboardMetrics(ifcId: string, deliveryUnit: string, engineer: string, sectionManager: string): Observable<any[]> {
    const requestbody = { "controlCenterName": ifcId, "deliveryUnit": deliveryUnit, "engineer": engineer, "sectionManager": sectionManager };
    return this.httpClient.post<any[]>(`${this.apiUrl}/dashboardMetrics`, requestbody, {});
  }

  public getDashboardRecords(mode: number, ifcId: number, deliveryUnit: string, engineer: string, sectionManager: string): Observable<any[]> {
    const requestBody = { "mode": mode, "ifcId": ifcId, "deliveryUnit": deliveryUnit, "engineer": engineer, "sectionManager": sectionManager };
    return this.httpClient.post<any[]>(`${this.apiUrl}/builtinBoard/search`, requestBody, {});
  }

  public getProblemByRouteId(ifcId: number) {
    return this.httpClient.get(`${this.apiUrl}/create/${ifcId}`, { responseType: 'text' });
  }

  public getProblemById(problemId: number): Observable<ProblemGetModel> {
    return this.httpClient.get<ProblemGetModel>(`${this.apiUrl}${problemId}`, {});
  }

  public postProblem(modelProblem) {
    return this.httpClient.post(`${this.apiUrl}`, modelProblem, {});
  }

  public getProblemRefSystemExist(refSystemId: number, ticketRefNumber: string) {
    return this.httpClient.get(`${this.apiUrl}/exist/${ticketRefNumber}/${refSystemId}`, {});
  }

  public getProblemList(problemId: number[]): Observable<ProblemSummaryModel[]> {
    const requestBody = { problemId: problemId };
    return this.httpClient.post<ProblemSummaryModel[]>(`${this.apiUrl}/problemList`, requestBody, {});
  }

  public getSearchProblemByCode(problemCode: string): Observable<SearchProblemCodeModel[]> {
    return this.httpClient.get<SearchProblemCodeModel[]>(`${this.apiUrl}/searchProblems/${problemCode}`, {});
  }

  public getProblemGobalSearch(paramsData: any): Observable<any> {
    return this.httpClient.post<ProblemGobalSearch[]>(`${this.apiUrl}/globalSearch`, paramsData, {});
  }

  public getTrustIncidentsById(problemId: number): Observable<TrustIncidentGetModel[]> {
    return this.httpClient.get<TrustIncidentGetModel[]>(`${this.apiUrl}/delayIncidents/${problemId}`, {});
  }

  public getTrustIncidentLinked(delayId: number) {
    return this.httpClient.get(`${this.apiUrl}/isDelayLinked/${delayId}`, {});
  }

  public postTrustIncidents(paramsData: any) {
    return this.httpClient.post(`${this.apiUrl}/delayIncident`, paramsData, {});
  }

  public getProblemRelationshipById(problemId: number): Observable<RelationshipGetModel[]> {
    return this.httpClient.get<RelationshipGetModel[]>(`${this.apiUrl}/problemRelationship/${problemId}`, {});
  }

  public postProblemRelationship(paramsData: any) {
    return this.httpClient.post(`${this.apiUrl}/relationship`, paramsData, { responseType: 'text' as 'json' });
  }

  public getNotes(type: string, pid: number): Observable<ProblemNotesGetModel[]> {
    let params = new HttpParams();
    params = params.append(type === 'FAILURE' ? 'problemId' : type === 'ASSIGNMENT' ? 'assignmentId' : 'peaId', pid + "");
    return this.httpClient.get<ProblemNotesGetModel[]>(`${this.apiUrl}/notes`, { params: params });
  }

  public postNote(notesObj: any) {
    return this.httpClient.post(`${this.apiUrl}/note`, notesObj, {});
  }

  public postProblemGeometry(problemGeometryModel): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl_GIS}/problemGeometry`, problemGeometryModel, {});
  }

  public postMobileNotification(
    title: string = "Failure", priority: string, recordType: string, faultCode: string, assignmentId: number,
    eqDesc: string, place: string, reason: string, special1: string) {

    let fault = title === 'Failure' ? 'New failure record ' + faultCode + ' issued' : 'Failure record ' + faultCode + ' cancelled';

    let payload = {
      "tags": special1,
      "payload": {
        "aps": {
          "alert": {
            "title": 'MyWork',
            "subtitle": title === 'Failure' ? 'New Failure' : 'New Cancelled',
            "body": fault + '\n' + eqDesc + '\n' + place
          },
          "sound": "default",
          "mutable-content": "1",
          "priority": priority,
          "messageId": Guid.create().toString(),
          "type": recordType,
          "linkedItemId": assignmentId,
          "FailureNumber": faultCode,
          "Reason": reason
        }
      }
    };

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(`${window.location.origin}/notify`, JSON.stringify(payload), { headers })
      .subscribe(data => {
        console.log('nofitication:', payload, data);
      });
  }

}
